export const GET_CERTIFICATES = "GET_CERTIFICATES";
export const GET_ALL_CERTIFICATES = "GET_ALL_CERTIFICATES";
